export const iconFontAwesomeHolidaysFaceKissWinkHeart = (
	<i className="fa-solid fa-face-kiss-wink-heart"></i>
);
